import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7555581e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "system-notification-detail-content"
};
const _hoisted_2 = {
  class: "detail-content"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "通知列表", -1));
const _hoisted_4 = {
  class: "notificationList_warp"
};
const _hoisted_5 = {
  class: "notificationList_time"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "item_title TextOverflow"
};
const _hoisted_8 = {
  class: "item_time TextOverflow"
};
const _hoisted_9 = {
  class: "notificationList_list"
};
const _hoisted_10 = ["id", "onClick"];
const _hoisted_11 = {
  key: 0,
  class: "hotRed"
};
const _hoisted_12 = {
  class: "titleBig"
};
const _hoisted_13 = ["innerHTML"];
const _hoisted_14 = {
  class: "footer"
};
const _hoisted_15 = {
  class: "user"
};
const _hoisted_16 = {
  class: "time"
};
import { postSelectAllUserNotice, postUpdateUserReadNoticeStatus } from '@/api/systemNotification';
import announcementTemplate from '@/components/announcementTemplate.vue';
import { OK } from '@/common';
import { onMounted, computed, ref } from 'vue';
import { useStore } from '@/store';
import { useHorn } from "@/hooks/useHorn.ts";
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const {
      getUserNotice
    } = useHorn();
    const allNotificationList = ref();
    const {
      userInfo
    } = useStore();
    const userInfoDate = computed(() => JSON.parse(userInfo));
    const selectCatalogueId = ref('');
    const AllUserNotice = async (title = '') => {
      const params = {
        userId: userInfoDate.value.id,
        title
      };
      try {
        const {
          code,
          data
        } = await postSelectAllUserNotice(params);
        if (code === OK) {
          allNotificationList.value = data.list;
        }
      } catch (e) {}
    };
    const selectCatalogue = id => {
      selectCatalogueId.value = id;
      const element = document.getElementById("notitfication-item-" + id);
      // 使用平滑滚动效果将元素滚动到可视区域内，并在垂直方向上居中对齐
      element && element.scrollIntoView({
        behavior: "auto",
        block: "start"
      });
    };
    const visibleAnnouncement = ref(false);
    const AnnouncementObj = ref({});
    const closeModal = () => {
      visibleAnnouncement.value = false;
    };
    const openModalAnnouncement = async item => {
      if (!item.isRead) {
        let params = {
          userId: userInfoDate.value.id,
          noticeIds: item.id
        };
        try {
          let {
            code
          } = await postUpdateUserReadNoticeStatus(params);
          if (code == OK) {
            AnnouncementObj.value = item;
            visibleAnnouncement.value = true;
            AllUserNotice();
            getUserNotice();
          }
        } catch (e) {}
      } else {
        AnnouncementObj.value = item;
        visibleAnnouncement.value = true;
      }
    };
    onMounted(() => {
      AllUserNotice();
    });
    return (_ctx, _cache) => {
      const _component_a_timeline_item = _resolveComponent("a-timeline-item");
      const _component_a_timeline = _resolveComponent("a-timeline");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_a_timeline, null, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allNotificationList.value, item => {
          return _openBlock(), _createBlock(_component_a_timeline_item, {
            key: item.id,
            class: _normalizeClass({
              'selected-item': selectCatalogueId.value === item.id
            })
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: "timelineItem",
              onClick: $event => selectCatalogue(item.id)
            }, [_createElementVNode("span", _hoisted_7, _toDisplayString(item.title), 1), _createElementVNode("span", _hoisted_8, _toDisplayString(item.sendTime), 1)], 8, _hoisted_6)]),
            _: 2
          }, 1032, ["class"]);
        }), 128))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allNotificationList.value, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "modal",
          key: item.id,
          id: `notitfication-item-${item.id}`,
          onClick: $event => openModalAnnouncement(item)
        }, [!item.isRead ? (_openBlock(), _createElementBlock("div", _hoisted_11)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_12, _toDisplayString(item.title), 1), _createElementVNode("div", {
          innerHTML: item.content,
          class: "preview"
        }, null, 8, _hoisted_13), _createElementVNode("div", _hoisted_14, [_createElementVNode("span", _hoisted_15, _toDisplayString(item.createUser), 1), _createElementVNode("span", _hoisted_16, "   " + _toDisplayString(item === null || item === void 0 ? void 0 : item.sendTime), 1)])], 8, _hoisted_10);
      }), 128))])])]), _createVNode(_component_a_modal, {
        open: visibleAnnouncement.value,
        "onUpdate:open": _cache[0] || (_cache[0] = $event => visibleAnnouncement.value = $event),
        onCancel: closeModal,
        width: "900px",
        centered: "",
        footer: false
      }, {
        default: _withCtx(() => [_createVNode(announcementTemplate, {
          announcementInfo: AnnouncementObj.value
        }, null, 8, ["announcementInfo"])]),
        _: 1
      }, 8, ["open"])]);
    };
  }
});